import { Navigate, useLocation } from 'react-router-dom';
import { vgraphDemoDefaultRoute } from '../../../../utils';
import { DemoView } from '../../../../components/demo-view';
import { copyWritings } from './copywritings';
import {
  VGraphNavigator,
  VGraphNavigatorMobile,
} from '../../components/navigator';

export function Demo() {
  const location = useLocation();
  if (location.pathname === '/vgraph/demo') {
    return <Navigate to={`/vgraph/demo/${vgraphDemoDefaultRoute}`} />;
  }

  return (
    <DemoView
      siteType="vgraph"
      navigator={<VGraphNavigator selected="example" />}
      navigatorMobile={<VGraphNavigatorMobile selected="example" />}
      copyWritings={copyWritings}
    />
  );
}
